import { Link } from 'react-router-dom';
import { Icons } from '@/components/icons';

const footerLinks = {
  product: [
    { label: 'Features', href: '/features' },
    { label: 'Pricing', href: '/pricing' },
    { label: 'How it works', href: '/how-it-works' },
  ],
};

export const LandingFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="py-16 px-4 border-t border-white/5">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row justify-between items-start gap-8 mb-12">
          {/* Brand */}
          <div className="max-w-xs">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="p-2 rounded-lg landing-glass">
                <Icons.logo className="w-5 h-5 text-cyan-400" />
              </div>
              <span className="font-bold text-white">Discovery Hub</span>
            </Link>
            <p className="text-sm landing-text-muted">
              AI-powered B2B lead generation platform for modern sales teams.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="font-semibold text-white mb-4">Product</h4>
            <ul className="space-y-3">
              {footerLinks.product.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.href}
                    className="text-sm landing-text-muted hover:text-white transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Copyright */}
        <div className="pt-8 border-t border-white/5 text-center">
          <p className="text-sm landing-text-muted">
            © {currentYear} Discovery Hub. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
